var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regist-success"},[_c('img',{attrs:{"src":require("@/assets/img/dq/reg_success.png")}}),_c('p',[_vm._v("您已注册成为万达个体商户")]),_c('div',{staticClass:"btn",on:{"click":_vm.goLogin}},[_vm._v("去登录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }